import { Component, ViewChild } from '@angular/core';
import { SearchSelector } from '@portal/shared/ui/filter/src/lib/search/enums/search-selector.enum';
import { SearchOperator } from '@portal/shared/ui/filter/src/lib/search/enums/search-operator.enum';
import { ProcessorTypes } from '@portal/entity-services/payment-contracts/src/lib/components/form/processor-type.list';
import { FILTER_CONTENT_ITEM } from '@portal/shared/ui/filter/src/lib/content/token';
import cloneDeep from 'lodash-es/cloneDeep';
import { FilterAutoCompleteInputComponent } from '../autocomplete/search-autocomplete-input.component';
import { ISelectInput } from '../box/interfaces/select-input.interface';
import { FilterBase } from '../filter-base';
import { SupportedProcessorSettingsService } from '@apps/portal/src/app/services/supported-processor-settings.service';

@Component({
  selector: 'portal-shared-service-provider-multi-select-filter',
  templateUrl: './service-provider-multi-select.component.html',
  providers: [
    {
      provide: FILTER_CONTENT_ITEM,
      useExisting: ServiceProviderMultiSelectComponent,
    },
  ],
  standalone: false,
})
export class ServiceProviderMultiSelectComponent extends FilterBase {
  @ViewChild('providerSearchInput', { static: true })
  providerSearchInput: FilterAutoCompleteInputComponent;
  entitiesProvidersList: ISelectInput[];

  constructor(
    processorTypes: ProcessorTypes,
    private supportedProcessorSettingService: SupportedProcessorSettingsService,
  ) {
    super(SearchSelector.Acquirer.toString(), processorTypes.getSupportedProcessors());
    this.entitiesProvidersList = processorTypes.list;
    this.supportedProcessorSettingService.isProcessorFetched$.subscribe(() => {
      this.updateListEntity(processorTypes.getSupportedProcessors());
    });
  }

  onSearch(searchValue: string): void {
    this.entities = cloneDeep(this.entitiesProvidersList);
    if (!searchValue) {
      this.searchedText = null;
    } else {
      this.searchedText = searchValue;
      this.entities = this.entities.filter((entity: ISelectInput) => {
        return entity.text.toLowerCase().includes(searchValue.toLowerCase());
      });
    }
    this.updateEntities();
  }

  updateEntities(): void {
    this.showSelectedEntities = cloneDeep(this.localPreSelectedEntities);
    this.entities = this.entities.filter((entity: ISelectInput) => {
      return !this.localPreSelectedEntities.has(entity.id);
    });
  }

  onFilterApplied(): void {
    this.updateEntities();
    const values: string[] = this.getValues();
    if (values.length) {
      this.filterApplied.emit({
        key: this.searchSelector,
        operator: SearchOperator.In,
        value: Array.from(this.localPreSelectedEntities.values()),
        argument: `(${Array.from(values).join(',')})`,
      });
      this.staticFilterUpdated.emit({
        key: this.searchSelector,
        value: Array.from(this.localPreSelectedEntities.values()),
      });
    } else {
      this.filterApplied.emit({
        key: this.searchSelector,
        toRemove: true,
      });
      this.staticFilterUpdated.emit({
        key: this.searchSelector,
        toRemove: true,
      });
    }
    this.itemToggled.emit();
    this.resetInputValue();
  }

  clear(): void {
    this.isOpen = false;
    this.onFilterClear();
  }

  onFilterClear(): void {
    this.removeAllEntities();
    this.resetInputValue();
  }

  removeAllEntities(): void {
    this.localPreSelectedEntities.clear();
    this.showSelectedEntities.clear();
  }

  resetInputValue(): void {
    this.providerSearchInput.reset();
    this.onSearch('');
  }
}
